/*
 * brand-name-case.js
 *
 * The brand name is written "SEic". Eyebrows, buttons, menu headings and breadcrumbs force
 * `text-transform: uppercase` in many sections, which turns it into "SEIC". CSS cannot exempt one
 * word inside an uppercase element, so this wraps each exact "SEic" that would be transformed in a
 * <span class="brand-name">, which sets `text-transform: none` (see brand-theme.css).
 * Only text nodes whose computed text-transform is uppercase/lowercase are touched, and a
 * MutationObserver covers content added later (filters, quick view, search results).
 */
(function () {
  var NAME = /SEic/;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1, SELECT: 1, TITLE: 1, CODE: 1, PRE: 1, SVG: 1, TEMPLATE: 1 };

  function transformsCase(el) {
    var t = getComputedStyle(el).textTransform;
    return t === 'uppercase' || t === 'lowercase';
  }

  function wrap(textNode) {
    var parts = textNode.nodeValue.split(/(SEic)/);
    var frag = document.createDocumentFragment();
    parts.forEach(function (part) {
      if (part === 'SEic') {
        var span = document.createElement('span');
        span.className = 'brand-name';
        span.textContent = part;
        frag.appendChild(span);
      } else if (part) {
        frag.appendChild(document.createTextNode(part));
      }
    });
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function scan(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!NAME.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var el = node.parentElement;
        if (!el || SKIP[el.tagName.toUpperCase()] || el.closest('.brand-name, [contenteditable="true"]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var hits = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (transformsCase(node.parentElement)) hits.push(node);
    }
    hits.forEach(wrap);
  }

  var queued = false;
  var pending = [];
  function flush() {
    queued = false;
    var batch = pending;
    pending = [];
    batch.forEach(function (n) {
      if (!n.isConnected) return;
      if (n.nodeType === 3) {
        if (NAME.test(n.nodeValue) && n.parentElement && !n.parentElement.closest('.brand-name') && transformsCase(n.parentElement)) wrap(n);
      } else if (n.nodeType === 1) {
        scan(n);
      }
    });
  }

  function start() {
    scan(document.body);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        r.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && n.classList && n.classList.contains('brand-name')) return;
          pending.push(n);
        });
      });
      if (pending.length && !queued) {
        queued = true;
        (window.requestAnimationFrame || window.setTimeout)(flush);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
